import { render, staticRenderFns } from "./EditTaxPage.vue?vue&type=template&id=0e81782d&scoped=true&"
import script from "./EditTaxPage.vue?vue&type=script&lang=js&"
export * from "./EditTaxPage.vue?vue&type=script&lang=js&"
import style0 from "./EditTaxPage.vue?vue&type=style&index=0&id=0e81782d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e81782d",
  null
  
)

export default component.exports